import { createAction } from 'redux-actions';
import I18n from 'I18n';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { CREATE_TICKET_SUCCESS, CREATE_TICKET_FAILED } from '../constants/ActionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const createTicketSuccess = createAction(CREATE_TICKET_SUCCESS, emptyFunction, () => ({
  notification: {
    message: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-ui.alerts.TICKET_CREATE_SUCCESS.description'
    }),
    titleText: I18n.text('conversations-inbox-ui.alerts.TICKET_CREATE_SUCCESS.title'),
    type: 'success'
  }
}));
export const createTicketFailed = createAction(CREATE_TICKET_FAILED, emptyFunction, () => ({
  notification: {
    message: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-ui.alerts.TICKET_CREATE_FAILED.description'
    }),
    titleText: I18n.text('conversations-inbox-ui.alerts.TICKET_CREATE_FAILED.title'),
    type: 'danger'
  }
}));